<style lang="less" scoped>
@import "./index.less";
</style>
<template>
  <div class="home-container">
    <div class="top-banner">
      <swiper class="banner-box" @transitionStart="bannerChange" :options="bannerOption" ref="bannerBox">
        <!-- slides -->
        <swiper-slide class="swiper-no-swiping" v-for="(banner, index) in topBanners" :key="index">
          <a :href="banner.url" v-if="banner.url">
            <img style="width: 1440px;height: 600px;object-fit: cover;" :src="banner.pathUrl" :alt="banner.name">
          </a>
          <img style="width: 1440px;height: 600px;object-fit: cover;" v-else :src="banner.pathUrl" :alt="banner.name">
        </swiper-slide>
      </swiper>

      <div class="banner-name-box">
        <swiper :options="bannerNameOption" ref="bannerNameBox">
          <!-- slides -->
          <swiper-slide class="swiper-no-swiping" v-for="(banner, index) in topBanners" :key="index">
            <div class="text-center banner-name-box__name" @click="changeBanner(index)"
              :class="(index == showIndex) ? 'activity' : ''">
              {{ banner.name }}</div>
          </swiper-slide>
        </swiper>
        <div class="btn-previous" @click="showPrevious"><i class="el-icon-caret-left"></i></div>
        <div class="btn-next" @click="showNext"><i class="el-icon-caret-right"></i></div>
      </div>
    </div>

    <div class="week-main product-list" v-if="weekMain.isShow">
      <div class="title">本月主打</div>
      <div class="product-list-box">
        <el-row :gutter="10">
          <el-col :span="6" v-for="(item, index) in weekMain.products" :key="index">
            <div class="product-box">
              <div class="album-preview-img">
                <el-tag v-if="$enums.productMark.label(item.tag)"
                  :class="`album-tag tag-${item.tag}`">{{ item.tag | enums('productMark') }}</el-tag>
                <component :is="item.link ? 'router-link' : 'span'" :to="item.link || ''"
                  :target="item.target || '_self'">
                  <img class="image-watermark" v-if="item.watermark" :src="item.watermarkImage">
                  <img class="image-fluid" :src="item.img | imgUrl" v-if="item.img" :alt="item.title" v-reload>
                  <img style="width: 100%;" :src="item.img | imgUrl" v-else :alt="item.title" v-reload>
                </component>
              </div>
              <div class="product-info text-center">
                <div class="product-name ellipsis">
                  {{ item.title }}
                </div>
                <div class="product-market-price">¥ {{ item.marketPrice }}</div>
                <div>
                  <span class="product-price">¥ {{ item.salePrice }}</span>
                  <span @click="addCart(item.productInfo)">
                    <svg-icon class="product-cart-icon" :icon-class="'cart-circle'" />
                  </span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="product-cate-show product-list" v-for="(cate, index) in productCates" :key="index" v-if="cate.isShow">
      <div style="height: 45px;">
        <div class="title fl">{{ cate.content.title }} </div>
        <router-link :to="{ path: 'list', query: { cateId: cate.content.cateId } }">
          <div class="more fr">查看更多 <i class="el-icon-caret-right"></i></div>
        </router-link>
      </div>

      <div v-if="cate.isShowBanner">
        <a :href="cate.content.bannerUrl" v-if="cate.content.bannerUrl">
          <img class="ad-banner" style="width: 1270px; height: 360px;object-fit: cover;" :src="cate.content.bannerPath"
            alt="加载失败">
        </a>

        <img class="ad-banner" style="width: 1270px; height: 360px;object-fit: cover;" :src="cate.content.bannerPath"
          v-else alt="加载失败">

      </div>

      <div class="product-list-box" v-if="cate.isShowProduct">
        <el-row :gutter="10">
          <el-col :span="6" v-for="(item, index) in getCateProduct(cate.content.mainProducts)" :key="index">
            <div class="product-box">
              <div class="album-preview-img">
                <el-tag v-if="$enums.productMark.label(item.tag)"
                  :class="`album-tag tag-${item.tag}`">{{ item.tag | enums('productMark') }}</el-tag>
                <component :is="item.link ? 'router-link' : 'span'" :to="item.link || ''"
                  :target="item.target || '_self'">
                  <img class="image-watermark" v-if="item.watermark" :src="item.watermarkImage">
                  <img class="image-fluid" :src="item.img | imgUrl" v-if="item.img" :alt="item.title" v-reload>
                  <img style="width: 100%;" :src="item.img | imgUrl" v-else :alt="item.title" v-reload>
                </component>
              </div>
              <div class="product-info text-center">
                <div class="product-name ellipsis">
                  {{ item.title }}
                </div>
                <div class="product-market-price">¥ {{ item.marketPrice }}</div>
                <div>
                  <span class="product-price">¥ {{ item.salePrice }}</span>
                  <span @click="addCart(item.productInfo)">
                    <svg-icon class="product-cart-icon" :icon-class="'cart-circle'" />
                  </span>
                </div>
              </div>
            </div>
          </el-col>

        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import moment from 'moment'
import _ from 'lodash'
import { isSellOut } from "@/helpers";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { createNamespacedHelpers } from 'vuex'
import CartOperator from '@/mixins/CartOperator'

const { mapState: pageSettingMapState } = createNamespacedHelpers('activityPageSettings')
const sallOutImagePath = require('@/assets/watermark/sell-out.png')

export default {
  mixins: [CartOperator],
  data: function () {
    return {
      bannerOption: {
        initialSlide: 0,
        autoplay: true,
        // loop: true,
        speed: 1000,
      },
      bannerNameOption: {
        initialSlide: 0,
        loop: false,
        slidesPerView: 5,
        speed: 150,
      },
      cateSettings: [],
      cateProducts: [],
      weekMain: {},
      products: [],
      showIndex: 0,
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...pageSettingMapState([
      'homeSettings'
    ]),
    topBanners() {
      return this.$store.state.activityBanners.collection ? this.$store.state.activityBanners.collection : []
    },
    productCates() {
      const cates = []
      const peoductKeys = ['watch', 'digital-piano', 'e-education', 'calculator']
      peoductKeys.forEach((item) => {
        let setting = this.findSettingByKey(item)
        setting = setting ? setting : {}
        if (!_.isEmpty(setting) && !_.isEmpty(setting.content)) {
          setting.isShow = true
          setting.isShowBanner = true
          setting.isShowProduct = true

          if (_.isEmpty(setting.content.bannerPath)) {
            setting.isShowBanner = false
          }

          if (_.isEmpty(setting.content.mainProducts)) {
            setting.isShowProduct = false
          }

          if (!setting.isShowBanner && !setting.isShowProduct) {
            setting.isShow = false
          }
        } else {
          setting.isShow = false
        }
        cates.push(setting)
      })
      return cates
    }
  },
  watch: {
    showIndex(newValue, oldValue) {
      if (this.$refs.bannerBox.swiper.activeIndex != newValue) {
        this.$refs.bannerBox.swiper.slideTo(newValue, 1000, true)
      }

      let index = newValue - 4
      index = index > 0 ? index : 0
      this.$refs.bannerNameBox.swiper.slideTo(index, 500, true)
    }
  },
  methods: {
    bannerChange() {
      this.showIndex = this.$refs.bannerBox.swiper.activeIndex
    },
    changeBanner(index) {
      this.showIndex = index
      this.$nextTick(() => {
        this.$refs.bannerBox.swiper.autoplay.start()
      })
    },
    findSettingByKey(key) {
      const re = this.homeSettings.find((item) => {
        return item.name == key
      })
      return re ? re : {}
    },
    async getProductsBySkus(skus = []) {
      const relsQuery = {
        productSpec: { sku: JSON.stringify(skus) }
      }
      const collection = await this.$store.dispatch('activityProducts/allCollection', { relsQuery })
      let products = []
      collection.forEach((item, index) => {
        products.push(this.formatProduct(item))
      })
      return products
    },
    addCart(productInfo) {
      const cart = { productInfo, num: 1 };
      this.addToCart(cart)
    },
    formatProduct(product) {
      return {
        title: product.productSpec.specName,
        img: product.productSpec.photos.length > 0 ? product.productSpec.photos[0].url : '',
        link: {
          name: 'product-detail',
          params: {
            id: product.id
          }
        },
        marketPrice: product.productSpec.price,
        salePrice: product.price,
        watermark: isSellOut(product),
        watermarkImage: isSellOut(product) ? sallOutImagePath : '',
        tag: product.mark,
        productInfo: product,
      }
    },
    async setWeekMain() {
      const setting = this.findSettingByKey('flagship')
      if (!_.isEmpty(setting.content) && !_.isEmpty(setting.content.mainProducts)) {
        setting.products = await this.getProductsBySkus(setting.content.mainProducts)
        setting.isShow = true
      } else {
        setting.products = []
        setting.isShow = false
      }
      this.weekMain = setting
    },
    async setProducts() {
      let skus = []
      this.productCates.forEach(item => {
        if (item.isShowProduct) {
          skus = skus.concat(item.content.mainProducts)
        }
      })
      this.products = await this.getProductsBySkus(skus)
    },
    getCateProduct(skus) {
      return this.products.filter((item) => {
        let sku = item.productInfo.productSpec.sku
        return skus.indexOf(sku) >= 0
      })
    },
    showNext() {
      this.$refs.bannerBox.swiper.slideNext()
    },
    showPrevious() {
      this.$refs.bannerBox.swiper.slidePrev()
    },
    async initPage() {
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      const query = {
        startTime: '<=' + now,
        endTime: '>=' + now,
      }
      const sorts = { weight: 'desc', id: 'desc' }
      await this.$store.dispatch('activityBanners/allCollection', { query, sorts })

      await this.$store.dispatch('activityPageSettings/getHomeSettings')
      await this.setWeekMain()
      await this.setProducts()
    }
  },
  async mounted() {
    if (!this.activity.homeShow) {
      this.$router.push('list')
    }
    await this.initPage();
  }

}
</script>
